import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
    name: 'localDate',
    pure: true,
    standalone: false
})
export class ToLocalDateTimePipe implements PipeTransform {
  transform(value: any, format: string) {
    if (!value) {
      return '';
    }
    if (!format) {
      format = 'd MMMM yyyy';
    }
    return formatDate(value, format, 'sv');
  }
}
